import { CustomCellDate, CrudLink } from "@/shared/components";
import { Chip, Stack, Typography } from "@mui/material";
import type { DataListViewColumns } from "@/shared/components/DataListView";
import type { LanguageRow } from "./types";
import type { ColumnDefinition } from "@/shared/components/CRUD/types";

export const getColumnsConfig = (): ColumnDefinition<LanguageRow>[] => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "code",
    label: "Код",
    options: {
      setCellHeaderProps: () => ({ style: { minWidth: 120 } }),
      customBodyRender: (data: unknown) => {
        const row = data as LanguageRow;
        return (
          <CrudLink id={row.id} tab="edit">
            {row.code}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "title",
    label: "Название",
    options: {
      setCellHeaderProps: () => ({ style: { minWidth: 160 } }),
    },
  },
  {
    name: "native",
    label: "Родное название",
    options: {
      setCellHeaderProps: () => ({ style: { minWidth: 160 } }),
    },
  },
  {
    name: "translation",
    label: "Перевод",
    options: {
      setCellHeaderProps: () => ({ style: { width: 140 } }),
      customBodyRender: (value: unknown) => (
        <Chip
          label={value ? "Вкл" : "Выкл"}
          color={value ? "success" : "default"}
          size="small"
        />
      ),
    },
  },
  {
    name: "createdAt",
    label: "Создан",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
];

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Языки",
  itemCreated: "Язык создан",
  itemUpdated: "Язык обновлён",
  createItem: "Добавить язык",
  refetchList: "Обновить список",
  deleteItems: "Удалить",
  itemsDeleted: "Удалено",
  restoreItems: "Восстановить",
  itemsRestored: "Восстановлено",
  cancel: "Отмена",
  editItem: "Язык",
  showTitle: "Детали",
});

// Колонки для мобильного представления: код с названием и признак перевода
export const getMobileColumnsConfig = (): DataListViewColumns<LanguageRow> => ({
  main: {
    title: "Язык",
    sx: { flex: 1, minWidth: 0 },
    renderCell: (row) => (
      <Stack sx={{ minWidth: 0 }}>
        <CrudLink id={row.id} tab="edit" noWrap>
          {row.code} — {row.title}
        </CrudLink>
        <Typography variant="body2" color="textSecondary" noWrap>
          {row.native ?? "—"}
        </Typography>
      </Stack>
    ),
  },
  translation: {
    title: "Перевод",
    sx: { width: 80, flexShrink: 0 },
    renderCell: (row) => (
      <Chip
        label={row.translation ? "Вкл" : "Выкл"}
        color={row.translation ? "success" : "default"}
        size="small"
      />
    ),
  },
});
